import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import QuantityInput from 'apps/quantityControls/components/QuantityInput';
import { reportQuantityChange } from '../utils/SubscriptionsAnalytics';
import { reportRecommendationsQuantityChange } from '../utils/RecommendationsAnalytics';

export default class SubscriptionsQuantityInputContainer extends PureComponent {
  static propTypes = {
    sku: PropTypes.string.isRequired,
    quantity: PropTypes.number,
    onQuantitySubmit: PropTypes.func.isRequired,
    isRecommendation: PropTypes.bool,
  };

  changeQuantity = (quantityDiff) => {
    const { onQuantitySubmit, isRecommendation, sku } = this.props;
    onQuantitySubmit(sku, quantityDiff);
    if (isRecommendation) {
      reportRecommendationsQuantityChange(this.props.quantity + quantityDiff, sku);
    } else {
      reportQuantityChange(this.props.quantity + quantityDiff, sku);
    }
  };

  render() {
    const { quantity } = this.props;

    return (
      <QuantityInput
        quantity={quantity}
        onQuantitySubmit={this.changeQuantity}
      />
    );
  }
}
